import { WidgetConfig, WidgetState } from '@livechat/widget-react';
import { useState } from 'react';

export type LiveChatTools = {
  openLiveChat: () => void;
  closeLiveChat: () => void;
  chatComponentProps: Partial<WidgetConfig>;
};

export const useLiveChat = (): LiveChatTools => {
  const [visibility, setVisibility] = useState<WidgetState['visibility']>('hidden');

  const chatComponentProps: LiveChatTools['chatComponentProps'] = {
    onVisibilityChanged: ({ visibility }) => setVisibility(visibility),
    visibility
  };

  return {
    openLiveChat: () => setVisibility('maximized'),
    closeLiveChat: () => setVisibility('hidden'),
    chatComponentProps
  };
};
